/**
 * Helper: Format Cart Error
 * -----------------------------------------------------------------------------
 * Formats an error description returned by the cart API into a display
 * string.
 *
 */

/**
 * Format a cart error description for display.
 * - Returns the description unchanged if it's already a string.
 * - Otherwise flattens the values of the description object, appends a full
 *   stop to any entry that doesn't already end with one, and joins them with
 *   the given separator.
 * @param {Object|String} errorDescription - Error description from add request.
 * @param {String} separator - Separator to join multiple error entries with.
 * @returns {String}
 */
export function formatCartError(errorDescription, separator) {
  if (typeof errorDescription === 'string') {
    return errorDescription;
  }

  return Object.values(errorDescription)
    .flat()
    .map((error) => (error.endsWith('.') ? error : `${error}.`))
    .join(separator);
}
